import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosMedical } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";
import { resolveMedicalScope } from "./medicalScope";

export const fetchAllergies = createAsyncThunk(
  "allergies/fetch",
  async (target, { rejectWithValue, getState }) => {
    try {
      const { userId, headers } = resolveMedicalScope(getState(), target);
      const { data } = await axiosMedical.get(ENDPOINTS.MEDICAL.ALLERGIES(userId), { headers });
      if (!Array.isArray(data)) {
        return rejectWithValue("Unexpected allergy response format.");
      }
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Failed to load allergies.",
      );
    }
  },
);

export const addAllergyRecord = createAsyncThunk(
  "allergies/add",
  async ({ userId, values }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(getState(), userId);
      const { data } = await axiosMedical.post(
        ENDPOINTS.MEDICAL.ALLERGIES(scopedUserId),
        values,
        { headers: { "Content-Type": "application/json", ...headers } },
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Failed to add allergy.",
      );
    }
  },
);

export const updateAllergyRecord = createAsyncThunk(
  "allergies/update",
  async ({ userId, id, values }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(getState(), userId);
      const { data } = await axiosMedical.put(
        ENDPOINTS.MEDICAL.UPDATE_ALLERGY(scopedUserId, id),
        values,
        { headers: { "Content-Type": "application/json", ...headers } },
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Failed to update allergy.",
      );
    }
  },
);

export const removeAllergyRecord = createAsyncThunk(
  "allergies/remove",
  async ({ userId, id }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(getState(), userId);
      await axiosMedical.delete(ENDPOINTS.MEDICAL.DELETE_ALLERGY(scopedUserId, id), { headers });
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Failed to remove allergy.",
      );
    }
  },
);
